import React from "react";
import extractDefinitions from "../extractDefinitions";
import View from "./View";
// I have no idea what this is meant to be as it's used as a component elsewhere
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Col = ({ children, ...rest }) => {
    const definition = extractDefinitions(children);
    //  TODO: Should we add a stack anyway?
    if (definition !== null &&
        !Array.isArray(definition) &&
        typeof definition === "object") {
        return {
            ...definition,
            ...rest
        };
    }
    return React.createElement(View, { ...rest }, definition);
};
export default Col;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29sLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbXBvbmVudHMvQ29sLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDMUIsT0FBTyxrQkFBa0IsTUFBTSx1QkFBdUIsQ0FBQztBQUV2RCxPQUFPLElBQUksTUFBTSxRQUFRLENBQUM7QUFFMUIsZ0ZBQWdGO0FBQ2hGLDhEQUE4RDtBQUM5RCxNQUFNLEdBQUcsR0FBRyxDQUFDLEVBQUUsUUFBUSxFQUFFLEdBQUcsSUFBSSxFQUFrQixFQUFPLEVBQUU7SUFDekQsTUFBTSxVQUFVLEdBQUcsa0JBQWtCLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDaEQsdUNBQXVDO0lBQ3ZDLElBQ0UsVUFBVSxLQUFLLElBQUk7UUFDbkIsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQztRQUMxQixPQUFPLFVBQVUsS0FBSyxRQUFRLEVBQzlCLENBQUM7UUFDRCxPQUFPO1lBQ0wsR0FBRyxVQUFVO1lBQ2IsR0FBRyxJQUFJO1NBQ1IsQ0FBQztJQUNKLENBQUM7SUFDRCxPQUFPLG9CQUFDLElBQUksT0FBSyxJQUFJLElBQUcsVUFBVSxDQUFRLENBQUM7QUFDN0MsQ0FBQyxDQUFDO0FBRUYsZUFBZSxHQUFHLENBQUMifQ==